var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "271px",
    height: "223px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#7e3edf",
    d: "M 133.5,-0.5 C 133.833,-0.5 134.167,-0.5 134.5,-0.5C 134.5,4.16667 134.5,8.83333 134.5,13.5C 130.629,13.815 126.962,13.4816 123.5,12.5C 126.833,8.16667 130.167,3.83333 133.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#4d2991",
    d: "M 134.5,-0.5 C 134.833,-0.5 135.167,-0.5 135.5,-0.5C 139.221,3.88825 142.555,8.55492 145.5,13.5C 141.833,13.5 138.167,13.5 134.5,13.5C 134.5,8.83333 134.5,4.16667 134.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#914efd",
    d: "M 123.5,12.5 C 126.962,13.4816 130.629,13.815 134.5,13.5C 134.5,16.8333 134.5,20.1667 134.5,23.5C 134.5,25.8333 134.5,28.1667 134.5,30.5C 132.25,33.9988 130.25,37.6654 128.5,41.5C 126.929,43.6351 125.596,45.9684 124.5,48.5C 115.199,48.7822 106.199,47.4488 97.5,44.5C 105.818,33.5188 114.485,22.8522 123.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#6031b1",
    d: "M 134.5,13.5 C 138.167,13.5 141.833,13.5 145.5,13.5C 148.185,16.1897 150.518,19.1897 152.5,22.5C 146.441,22.2539 140.441,22.5872 134.5,23.5C 134.5,20.1667 134.5,16.8333 134.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d38c7",
    d: "M 152.5,22.5 C 154.471,24.8082 156.471,27.1415 158.5,29.5C 151.55,28.4069 144.55,28.2402 137.5,29C 136.584,29.2784 135.918,29.7784 135.5,30.5C 135.167,30.5 134.833,30.5 134.5,30.5C 134.5,28.1667 134.5,25.8333 134.5,23.5C 140.441,22.5872 146.441,22.2539 152.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e44d8",
    d: "M 158.5,29.5 C 160.758,32.3566 162.758,35.3566 164.5,38.5C 155.981,36.7057 147.314,36.0391 138.5,36.5C 136.992,34.8185 135.992,32.8185 135.5,30.5C 135.918,29.7784 136.584,29.2784 137.5,29C 144.55,28.2402 151.55,28.4069 158.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5826ad",
    d: "M 134.5,30.5 C 134.833,30.5 135.167,30.5 135.5,30.5C 135.992,32.8185 136.992,34.8185 138.5,36.5C 139.167,38.5 139.833,40.5 140.5,42.5C 136.298,42.8168 132.298,42.4834 128.5,41.5C 130.25,37.6654 132.25,33.9988 134.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9660e4",
    d: "M 138.5,36.5 C 147.314,36.0391 155.981,36.7057 164.5,38.5C 167.2,40.2344 169.2,42.5677 170.5,45.5C 161.015,43.3472 151.348,42.3472 141.5,42.5C 141.167,42.5 140.833,42.5 140.5,42.5C 139.833,40.5 139.167,38.5 138.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9f6ae8",
    d: "M 141.5,42.5 C 151.348,42.3472 161.015,43.3472 170.5,45.5C 174.064,49.6143 177.397,53.9476 180.5,58.5C 180.037,63.2619 177.704,66.7619 173.5,69C 168.201,71.908 162.535,73.408 156.5,73.5C 155.599,72.7095 154.932,71.7095 154.5,70.5C 162.543,70.6604 169.043,67.6604 174,61.5C 174.548,54.3578 171.382,49.5245 164.5,47C 157.339,44.8217 150.005,43.9884 142.5,44.5C 141.662,44.1583 141.328,43.4916 141.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f3fe0",
    d: "M 97.5,44.5 C 106.199,47.4488 115.199,48.7822 124.5,48.5C 123.153,51.1932 121.82,53.8599 120.5,56.5C 120.167,56.5 119.833,56.5 119.5,56.5C 110.815,55.9845 102.148,54.4845 93.5,52C 92.944,51.6174 92.6107,51.1174 92.5,50.5C 94.177,48.4602 95.8437,46.4602 97.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c090f6",
    d: "M 145.5,50.5 C 152.206,49.4075 158.039,51.0742 163,55.5C 163.687,57.9203 163.187,60.087 161.5,62C 158.392,63.7585 155.059,64.5919 151.5,64.5C 150.87,62.2504 149.87,60.2504 148.5,58.5C 147.501,55.8382 146.501,53.1716 145.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad7aee",
    d: "M 142.5,44.5 C 150.005,43.9884 157.339,44.8217 164.5,47C 171.382,49.5245 174.548,54.3578 174,61.5C 169.043,67.6604 162.543,70.6604 154.5,70.5C 154.5,69.8333 154.167,69.5 153.5,69.5C 153.107,67.7162 152.441,66.0495 151.5,64.5C 155.059,64.5919 158.392,63.7585 161.5,62C 163.187,60.087 163.687,57.9203 163,55.5C 158.039,51.0742 152.206,49.4075 145.5,50.5C 143.992,48.8185 142.992,46.8185 142.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#682ed4",
    d: "M 128.5,41.5 C 132.298,42.4834 136.298,42.8168 140.5,42.5C 140.833,42.5 141.167,42.5 141.5,42.5C 141.328,43.4916 141.662,44.1583 142.5,44.5C 142.992,46.8185 143.992,48.8185 145.5,50.5C 146.501,53.1716 147.501,55.8382 148.5,58.5C 148.265,59.0967 147.765,59.4301 147,59.5C 138.296,57.3913 129.463,56.3913 120.5,56.5C 121.82,53.8599 123.153,51.1932 124.5,48.5C 125.596,45.9684 126.929,43.6351 128.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e31c4",
    d: "M 92.5,50.5 C 92.6107,51.1174 92.944,51.6174 93.5,52C 102.148,54.4845 110.815,55.9845 119.5,56.5C 118.674,59.4848 117.341,62.1515 115.5,64.5C 115.389,63.8826 115.056,63.3826 114.5,63C 104.996,62.4714 95.6623,60.9714 86.5,58.5C 88.1468,55.5265 90.1468,52.8599 92.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7239de",
    d: "M 119.5,56.5 C 119.833,56.5 120.167,56.5 120.5,56.5C 129.463,56.3913 138.296,57.3913 147,59.5C 147.765,59.4301 148.265,59.0967 148.5,58.5C 149.87,60.2504 150.87,62.2504 151.5,64.5C 152.441,66.0495 153.107,67.7162 153.5,69.5C 153.631,70.2389 153.464,70.9056 153,71.5C 140.972,66.0778 128.472,64.4111 115.5,66.5C 115.5,65.8333 115.5,65.1667 115.5,64.5C 117.341,62.1515 118.674,59.4848 119.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#caa3ff",
    d: "M 57.5,61.5 C 58.8333,62.1667 58.8333,62.1667 57.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#935ce2",
    d: "M 180.5,58.5 C 181.803,60.1423 183.136,61.8089 184.5,63.5C 181.814,68.8668 177.481,72.3668 171.5,74C 166.997,75.7797 162.33,76.613 157.5,76.5C 156.89,75.609 156.557,74.609 156.5,73.5C 162.535,73.408 168.201,71.908 173.5,69C 177.704,66.7619 180.037,63.2619 180.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6227b1",
    d: "M 86.5,58.5 C 95.6623,60.9714 104.996,62.4714 114.5,63C 115.056,63.3826 115.389,63.8826 115.5,64.5C 115.5,65.1667 115.5,65.8333 115.5,66.5C 114.833,67.1667 114.167,67.8333 113.5,68.5C 103.22,66.8392 92.8871,64.8392 82.5,62.5C 83.5,60.8333 84.8333,59.5 86.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#844bda",
    d: "M 184.5,63.5 C 187.323,66.4751 189.656,69.8084 191.5,73.5C 181.241,76.6967 170.908,79.6967 160.5,82.5C 159.5,80.5 158.5,78.5 157.5,76.5C 162.33,76.613 166.997,75.7797 171.5,74C 177.481,72.3668 181.814,68.8668 184.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#591fa1",
    d: "M 82.5,62.5 C 92.8871,64.8392 103.22,66.8392 113.5,68.5C 113.34,70.153 112.674,71.4863 111.5,72.5C 110.848,71.2749 109.681,70.6083 108,70.5C 98.6908,69.5379 89.5241,67.8712 80.5,65.5C 81.1667,64.5 81.8333,63.5 82.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#4c148c",
    d: "M 80.5,65.5 C 89.5241,67.8712 98.6908,69.5379 108,70.5C 109.681,70.6083 110.848,71.2749 111.5,72.5C 110.833,74.1667 110.167,75.8333 109.5,77.5C 109.167,77.5 108.833,77.5 108.5,77.5C 98.131,77.0774 87.9643,75.4107 78,72.5C 76.9701,72.1639 76.4701,71.4972 76.5,70.5C 77.604,68.6115 78.9373,66.9448 80.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#430d7e",
    d: "M 76.5,70.5 C 76.4701,71.4972 76.9701,72.1639 78,72.5C 87.9643,75.4107 98.131,77.0774 108.5,77.5C 108.107,79.2838 107.441,80.9505 106.5,82.5C 95.8171,79.4964 85.1504,76.4964 74.5,73.5C 74.427,71.9731 75.0937,70.9731 76.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e4ae8",
    d: "M 153.5,69.5 C 154.167,69.5 154.5,69.8333 154.5,70.5C 154.932,71.7095 155.599,72.7095 156.5,73.5C 156.557,74.609 156.89,75.609 157.5,76.5C 158.5,78.5 159.5,80.5 160.5,82.5C 160.5,83.1667 160.167,83.5 159.5,83.5C 157.833,84.1667 156.167,84.8333 154.5,85.5C 140.731,76.3997 125.731,73.7331 109.5,77.5C 110.167,75.8333 110.833,74.1667 111.5,72.5C 112.674,71.4863 113.34,70.153 113.5,68.5C 114.167,67.8333 114.833,67.1667 115.5,66.5C 128.472,64.4111 140.972,66.0778 153,71.5C 153.464,70.9056 153.631,70.2389 153.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#cba0fe",
    d: "M 43.5,76.5 C 44.7125,77.4971 44.5458,78.4971 43,79.5C 42.5304,78.4232 42.6971,77.4232 43.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8756ef",
    d: "M 154.5,85.5 C 153.167,86.5 151.833,87.5 150.5,88.5C 148.95,89.4408 147.284,90.1075 145.5,90.5C 141.297,86.7375 136.297,84.5709 130.5,84C 124.161,83.6516 117.827,83.8183 111.5,84.5C 110.167,84.1667 108.833,83.8333 107.5,83.5C 106.833,83.5 106.5,83.1667 106.5,82.5C 107.441,80.9505 108.107,79.2838 108.5,77.5C 108.833,77.5 109.167,77.5 109.5,77.5C 125.731,73.7331 140.731,76.3997 154.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#2b0b4f",
    d: "M 74.5,73.5 C 85.1504,76.4964 95.8171,79.4964 106.5,82.5C 106.5,83.1667 106.833,83.5 107.5,83.5C 108.41,86.9922 110.076,89.9922 112.5,92.5C 113.561,95.6223 114.895,98.6223 116.5,101.5C 107.785,100.859 99.1186,99.8594 90.5,98.5C 84.4212,90.6836 79.0879,82.3503 74.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#2b0b50",
    d: "M 191.5,73.5 C 186.333,83.1742 180.666,92.5076 174.5,101.5C 174.03,100.307 173.03,99.6399 171.5,99.5C 164.846,100.347 158.18,101.014 151.5,101.5C 151.5,100.833 151.5,100.167 151.5,99.5C 153.341,97.1515 154.674,94.4848 155.5,91.5C 157.341,89.1515 158.674,86.4848 159.5,83.5C 160.167,83.5 160.5,83.1667 160.5,82.5C 170.908,79.6967 181.241,76.6967 191.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a370e9",
    d: "M 107.5,83.5 C 108.833,83.8333 110.167,84.1667 111.5,84.5C 113.349,85.593 115.016,86.9263 116.5,88.5C 114.806,89.5274 113.473,90.8608 112.5,92.5C 110.076,89.9922 108.41,86.9922 107.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9466f8",
    d: "M 145.5,90.5 C 145.5,90.8333 145.5,91.1667 145.5,91.5C 141.7,93.2336 138.034,95.2336 134.5,97.5C 130.711,95.0367 126.711,93.0367 122.5,91.5C 120.819,89.9925 118.819,88.9925 116.5,88.5C 115.016,86.9263 113.349,85.593 111.5,84.5C 117.827,83.8183 124.161,83.6516 130.5,84C 136.297,84.5709 141.297,86.7375 145.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a877ec",
    d: "M 159.5,83.5 C 158.674,86.4848 157.341,89.1515 155.5,91.5C 154.599,89.2729 152.933,88.2729 150.5,88.5C 151.833,87.5 153.167,86.5 154.5,85.5C 156.167,84.8333 157.833,84.1667 159.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b488f0",
    d: "M 116.5,88.5 C 118.819,88.9925 120.819,89.9925 122.5,91.5C 117.306,93.5553 115.639,97.2219 117.5,102.5C 116.833,102.5 116.5,102.167 116.5,101.5C 114.895,98.6223 113.561,95.6223 112.5,92.5C 113.473,90.8608 114.806,89.5274 116.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc93f6",
    d: "M 150.5,88.5 C 152.933,88.2729 154.599,89.2729 155.5,91.5C 154.674,94.4848 153.341,97.1515 151.5,99.5C 151.365,95.3729 149.365,92.7062 145.5,91.5C 145.5,91.1667 145.5,90.8333 145.5,90.5C 147.284,90.1075 148.95,89.4408 150.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8a3fd",
    d: "M 122.5,91.5 C 126.711,93.0367 130.711,95.0367 134.5,97.5C 138.034,95.2336 141.7,93.2336 145.5,91.5C 149.365,92.7062 151.365,95.3729 151.5,99.5C 151.5,100.167 151.5,100.833 151.5,101.5C 149.659,103.849 148.326,106.515 147.5,109.5C 144.595,114.307 141.928,119.307 139.5,124.5C 135.766,124.677 132.099,124.344 128.5,123.5C 126.197,118.554 123.531,113.887 120.5,109.5C 119.773,107.046 118.773,104.713 117.5,102.5C 115.639,97.2219 117.306,93.5553 122.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#290b48",
    d: "M 90.5,98.5 C 99.1186,99.8594 107.785,100.859 116.5,101.5C 116.5,102.167 116.833,102.5 117.5,102.5C 118.773,104.713 119.773,107.046 120.5,109.5C 112.424,109.492 104.424,108.825 96.5,107.5C 94.2651,104.709 92.2651,101.709 90.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#290b48",
    d: "M 174.5,101.5 C 173.167,103.833 171.833,106.167 170.5,108.5C 162.842,108.986 155.175,109.32 147.5,109.5C 148.326,106.515 149.659,103.849 151.5,101.5C 158.18,101.014 164.846,100.347 171.5,99.5C 173.03,99.6399 174.03,100.307 174.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#52108e",
    d: "M 72.5,100.5 C 73.1894,99.2264 74.0228,99.2264 75,100.5C 75.9819,101.759 76.3152,103.092 76,104.5C 75.0513,102.907 73.8846,101.574 72.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#270b3e",
    d: "M 96.5,107.5 C 104.424,108.825 112.424,109.492 120.5,109.5C 123.531,113.887 126.197,118.554 128.5,123.5C 130.075,127.078 132.075,130.411 134.5,133.5C 136.432,130.634 138.099,127.634 139.5,124.5C 141.928,119.307 144.595,114.307 147.5,109.5C 155.175,109.32 162.842,108.986 170.5,108.5C 158.887,127.44 146.887,146.107 134.5,164.5C 121.092,146.024 108.425,127.024 96.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#af83eb",
    d: "M 128.5,123.5 C 132.099,124.344 135.766,124.677 139.5,124.5C 138.099,127.634 136.432,130.634 134.5,133.5C 132.075,130.411 130.075,127.078 128.5,123.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.c398efd6d8bc68d87525052378a488b2.svg";
export { ForwardRef as ReactComponent };